export default "__VITE_ASSET__2ed3c275__"